import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'sortBy'})
export class SortByPipe<T> implements PipeTransform {
  transform(original: T[], options = {}): T {
    const opts = Object.merge({
      sortBy: '',
      reverse: false
    }, options)

    return this.sortBy(original, opts['sortBy'], opts['reverse'])
  }

  private sortBy(objects: any[], sortBy = '', reverse = false): any {
    if (!objects || sortBy === '') {
      return objects
    }
    const sorted = [...objects]
    return sorted.sortBy((a) => {
      return Object.get(a, sortBy) || -1
    }, reverse)
  }
}
